// extracted by mini-css-extract-plugin
module.exports = {"container":"ShippingInstructions_container__35mSL","headingBlock":"ShippingInstructions_headingBlock__2lKuk","buttonsWrapper":"ShippingInstructions_buttonsWrapper__1CLQ3"};